module.exports = __webpack_public_path__ + "img/structureImg2.eb0c7577.png";